import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal_item_comp = _resolveComponent("modal-item-comp")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modals, (modal, index) => {
    return (_openBlock(), _createBlock(_component_modal_item_comp, {
      key: modal.uuid,
      modal: modal,
      index: _ctx.baseZIndex + index
    }, null, 8, ["modal", "index"]))
  }), 128))
}